import { Inject, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from "@angular/common";
import { LOCALE_ID } from '@angular/core';

@Pipe({
  name: 'dateTransformer',
  standalone: false
})
export class DateTransformerPipe implements PipeTransform {

  formats: Record<string, string> = {
    'DATE': 'dd/MM/yyyy',
    'TIME': 'HH:mm:ss',
    'SERVER': 'yyyy-MM-ddTHH:mm:ss.SSS Z',
    'EDIT': 'yyyy-MM-ddTHH:mm:ss',
    'DEFAULT': 'dd/MM/yyyy\xa0\xa0\xa0\xa0HH:mm:ss'
  };

  constructor(@Inject(LOCALE_ID) private locale: string) { }

  transform(value: string | Date | null | undefined, args?: string): string | null {
    if (!value) {
      console.error('Invalid pipe value:', value);
      return null;
    }

    let date: Date;
    if (value instanceof Date) {
      date = value;
    } else {
      const normalizedValue = value
        .trim()
        .replace(/\s+([+-]\d{2})(\d{2})$/, '$1:$2')
        .replace(/\s+Z$/, 'Z');

      date = new Date(normalizedValue);
      if (isNaN(date.getTime())) {
        const withoutTimezone = normalizedValue
          .replace(/[+-]\d{2}:\d{2}$/, '')
          .replace(/[+-]\d{4}$/, '')
          .trim();
        date = new Date(withoutTimezone);
      }
    }
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', value);
      return null;
    }

    const formatKey = args?.toUpperCase() || 'DEFAULT';
    const formatString = this.formats[formatKey] || this.formats['DEFAULT'];

    return formatDate(date, formatString, this.locale);
  }
}

